
export class FormLogicHelper {
  public static getQueryParams = () : any => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key.toLowerCase()] = value;
    });
    return params;
  }

  public static scrollToInvalidField = (formFieldsRef) => {
    setTimeout(() => {
      if (formFieldsRef.current) {
        const invalidElement = formFieldsRef.current.querySelector('.form__invalid-feedback');
        if (invalidElement) {
          invalidElement.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 100);
    
  }
  
  public static scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({
        top: 90,
        left: 0,
        behavior: "smooth",
      });
      
    }, 100);
  }

  public static isDefaultValueFromApi = (value) => {
    // Check for null or undefined
    if (value === null || value === undefined) {
      return true;
    }

    // Check if value is 0 (for numbers)
    if (typeof value === 'number' && value === 0) {
      return true;
    }

    // Check if value is C# DateTime.MinValue equivalent (1/1/0001 12:00:00 AM)
    const dateTimeMinValue = new Date(0); // C# DateTime.MinValue as Unix time epoch (0 ticks)
    dateTimeMinValue.setUTCFullYear(1); // Year 1
    if (value instanceof Date && value.getTime() === dateTimeMinValue.getTime()) {
      return true;
    }

    return false;
  };
}

